// External libraries
import React from 'react';
import { number, string } from 'prop-types';
import { LoadingElement } from '@checkout/react-components';

const LoadingFields = props => {
  const { numLoaders, styleOverrides } = props;
  const loaders = new Array(numLoaders);

  return (
    <>
      {Array.apply(null, loaders).map((_, i) => (
        <LoadingElement key={i} styleOverrides={styleOverrides} />
      ))}
    </>
  );
};

LoadingFields.defaultProps = {
  numLoaders: 5,
};

LoadingFields.propTypes = {
  numLoaders: number,
  styleOverrides: string,
};

export { LoadingFields };
